import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
  fetchProductsApi,
  createProductsApi,
  updateProductsApi,
  filterProductsApi,
  fetchProductsByIdApi,
  fetchProductCapsules,
  fetchBrandOptions,
  fetchCategoryOptions,
} from "../../../api/endpoint";

function* getProductsSaga(action) {
  try {
    const _api = yield call(fetchProductsApi, action.payload);
    yield put(actions.setProducts(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getProductCapsuleTypes(action) {
  try {
    const _api = yield call(fetchProductCapsules, action.payload);
    yield put(actions.setCapsuleTypes(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getBrandOptionsSaga(action) {
  try {
    const _api = yield call(fetchBrandOptions, action.payload);
    yield put(actions.setBrandOptions(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getCategoryOptionsSaga(action) {
  try {
    const _api = yield call(fetchCategoryOptions, action.payload);
    yield put(actions.setCategoryOptions(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getProductsIdSaga(action) {
  try {
    const _api = yield call(fetchProductsByIdApi, action.payload);
    yield put(actions.setProductsById(..._api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* createProductsSaga(action) {
  try {
    const _api = yield call(createProductsApi, action.payload);
    if (_api?.data?.success) {
      yield put(commonActions.setLoading(false));
      yield put(commonActions.setRedirect(true));
      yield put(
        commonActions.setAlert({
          message: "Product Successfully Added",
          alertType: "success",
          alertStatus: true,
        })
      );
    }
  } catch (error) {
    console.log("", error, error?.response?.data);
    yield put(commonActions.setError(true));
    yield put(commonActions.setRedirect(false));
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message,
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
  }
}

function* updateProductsSaga(action) {
  try {
    const _api = yield call(updateProductsApi, action.payload);
    if (_api?.data?.success) {
      // yield put(actions.setUpdatedProduct(action.payload));
      yield put(commonActions.setLoading(false));
      yield put(commonActions.setRedirect(true));
      yield put(
        commonActions.setAlert({
          message: "Product Successfully Updated",
          alertType: "success",
          alertStatus: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(commonActions.setError(true));
    yield put(commonActions.setRedirect(false));
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message,
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
  }
}

function* filterProductsSaga(action) {
  try {
    const _api = yield call(filterProductsApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setFilteredProducts(_api.data.results));
      yield put(commonActions.setClearFilter(true));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* watchProductsSaga() {
  yield all([
    takeEvery(actionTypes.GET_PRODUCTS, getProductsSaga),
    takeEvery(actionTypes.GET_PRODUCTS_BY_ID, getProductsIdSaga),
    takeEvery(actionTypes.CREATE_PRODUCT, createProductsSaga),
    takeEvery(actionTypes.UPDATE_PRODUCT, updateProductsSaga),
    takeEvery(actionTypes.GET_FILTERED_PRODUCTS, filterProductsSaga),
    takeEvery(actionTypes.GET_PRODUCTS_CAPSULES, getProductCapsuleTypes),
    takeEvery(actionTypes.GET_BRAND_OPTIONS, getBrandOptionsSaga),
    takeEvery(actionTypes.GET_CATEGORY_OPTIONS, getCategoryOptionsSaga),
  ]);
}
